// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import Base from '../../../global/components/BaseComponent.js.jsx';

import auditLogUtils from '../../../global/utils/auditLogUtils';

class AuditLogListItem extends Base {
  constructor(props) {
    super(props);
  }

  render() {
    const { auditLog, userStore } = this.props;

    let diffFields = auditLogUtils.findObjDiffFields(auditLog.originalObject, auditLog.newObject)
    // console.log("diff fields", diffFields)
    return (
      <div key={auditLog._id}>
        <hr/>
        <p>{auditLog.created}</p>
        {
          auditLog._user ? 
          <p>USER: {userStore.byId[auditLog._user] ? userStore.byId[auditLog._user].username : auditLog._user}</p>
          : auditLog.automated ?
          <p>USER - Automated System Call</p>
          :
          <p>Error determining User</p>
        }
        <p>Description: {auditLog.description}</p>
        <p>Origin app: {auditLog.originApp || 'n/a'}</p>
        <p>Changes:</p>
        { diffFields.filter(f => f !== "updated" && f !== "__v").map((field) => 
          <p>
            Field: {field}
            <br/>
            Old value: {JSON.stringify(auditLog.originalObject[field])}
            <br/>
            New value: {JSON.stringify(auditLog.newObject[field])}
          </p>
        )}

      </div>
    )
  }
}

AuditLogListItem.propTypes = {
  auditLog: PropTypes.object.isRequired
}

const mapStoreToProps = (store) => {
  /**
  * NOTE: Yote refer's to the global Redux 'state' as 'store' to keep it mentally
  * differentiated from the React component's internal state
  */
  return {
    auditLogStore: store.auditLog
    , certificateTemplateStore: store.certificateTemplate
    , courseStore: store.course
    , moduleCertificateStore: store.moduleCertificate
    , sceneStore: store.scene
    , sponsorStore: store.sponsor
    , contentModuleStore: store.contentModule
    , userStore: store.user
  }
}

export default connect(
  mapStoreToProps
)(AuditLogListItem)
;


// WEBPACK FOOTER //
// modules/auditLog/components/AuditLogListItem.js.jsx